import { render, staticRenderFns } from "./bulletin-board.vue?vue&type=template&id=2f428334&scoped=true"
import script from "./bulletin-board.vue?vue&type=script&lang=js"
export * from "./bulletin-board.vue?vue&type=script&lang=js"
import style0 from "./bulletin-board.vue?vue&type=style&index=0&id=2f428334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f428334",
  null
  
)

export default component.exports